import { connect } from 'react-redux';
import Dashboard from '../../../components/Pages/Dashboard';
import { fetchDashboardStats } from '../../../actions/dashboard';

const mapStateToProps = (state) => ({
  stats: state.dashboardStats,
  filters: state.dashboardFilter
});

const mapDispatchToProps = {
  fetchStats: fetchDashboardStats
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/containers/Pages/Dashboard/index.js